<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Bkaz35/tc-custom/9780226463636.jpg?1733038152474" alt="This image is the cover for the book Visualizing Disease"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Visualizing Disease
      </h1>
      <p class="bookDescription body article font2">
        <p>Visual anatomy books have been a staple of medical practice and study since the mid-sixteenth century. But the visual representation of diseased states followed a very different pattern from anatomy, one we are only now beginning to investigate and understand. With <i>Visualizing Disease</i>, Domenico Bertoloni Meli explores key questions in this domain, opening a new field of inquiry based on the analysis of a rich body of arresting and intellectually challenging images reproduced here both in black and white and in color.<br/>  <br/> Starting in the Renaissance, Bertoloni Meli delves into the wide range of figures involved in the early study and representation of disease, including not just men of medicine, like anatomists, physicians, surgeons, and pathologists, but also draftsmen and engravers. Pathological preparations proved difficult to preserve and represent, and as Bertoloni Meli takes us through a number of different cases from the Renaissance to the mid-nineteenth century, we gain a new understanding of how knowledge of disease, interactions among medical men and artists, and changes in the technologies of preservation and representation of specimens interacted to slowly bring illustration into the medical world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Domenico Bertoloni Meli
      </h2>
      
      <p class="authorDescription body article"><B>Domenico Bertoloni Meli</B> is provost professor of history and philosophy of science and medicine at Indiana University, Bloomington.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08cae733